<template>
  <div class="vz-light-order-wrapping">
    <vz-wrapping-group
      v-for="item in wrappingTypesLightOrder"
      :item="item"
      :wrapping="wrapping"
      @change="wrappingChange"
    />
  </div>
</template>

<script setup lang="ts">
import {useWrappingStore} from '~/stores/wrapping';
import {useOrderStore} from '~/stores/order';
import {OrderWrappingItem, OrderWrappingType} from '~/types/types';
import {getOrderWrappingTypesByLocation} from '@/api/wrapping';
import {deepCopyObject} from '~/common/functions';
import VzWrappingGroup from '~/components/personal/order/cargo/parts/vz-wrapping-group.vue';

const emit = defineEmits(['save'])

const orderStore = useOrderStore()
const wrappingStore = useWrappingStore()

// полная информация по типам упаковки, доступных для данной локации
const wrappingTypes = ref ([] as OrderWrappingType[])
const wrapping = ref([] as OrderWrappingItem[])

const mode = computed(() => {
  return orderStore.orderForm.cargo.mode
})

const specialGroups = computed(() => {
  return mode.value === 'dimension' ? ['palletCollar', 'hardPackage', 'hardPackage_WP', 'palletizing', 'palletizingOD'] : []
})

const wrappingTypesLightOrder = computed(() => {
  return wrappingTypes.value.filter(item => item.code && ["hardPackage", "hardPackage_WP"].includes(item.code))
})

async function updateWrappingTypes() {
  // типы упаковки, доступные в данной локации
  const locationWrappingTypes = await getOrderWrappingTypesByLocation(orderStore.orderForm.directions.dispatch.locationGuid)
  const orderWrappingTypes = deepCopyObject(wrappingStore.orderWrappingTypes) as OrderWrappingType[]

  wrappingTypes.value = orderWrappingTypes.filter((orderWrappingItem) => {
    const code = orderWrappingItem.list ? orderWrappingItem.list[0]?.code : ''

    return locationWrappingTypes.find((item) => {
      return item.code === code && !item.disabled
    })
  })
}


function onShow() {
  if (mode.value === 'dimension') {
    wrapping.value = deepCopyObject(orderStore.orderForm.cargo.dimensions.wrapping) as OrderWrappingItem[]
  } else if (mode.value === 'pallets' || mode.value === 'places') {
    // wrapping.value = deepCopyObject(orderStore.orderForm.cargo[mode.value].items[0].wrapping) as OrderWrappingItem[]
    wrapping.value = []

    let itemsWrapping: OrderWrappingItem[] = []
    orderStore.orderForm.cargo[orderStore.orderForm.cargo.mode].items.forEach((item) => {
      itemsWrapping = [...itemsWrapping, ...item.wrapping]
    })
    itemsWrapping.forEach((item) => {
      if (!wrapping.value.find(dataItem => dataItem.code === item.code)) {
        wrapping.value.push(item)
      }
    })
  }
  updateWrappingTypes()
}

function wrappingChange(status: boolean, code: string, groupCode: string, count?: number) {
  if (status) {
    checkSpecialGroups(groupCode)
    wrapping.value.push({
      code,
      value: count || 1
    })
  } else {
    wrapping.value = wrapping.value.filter((item) => { return item.code !== code })
  }
  nextTick(() => {
    save()
  })
}

function getGroupCode(code: string) {
  let data
  let groupCode = ''
  wrappingTypes.value.forEach((element) => {
    data = element.list.find((item) => {
      return item.code === code
    })
    if (data && element.id === null) {
      groupCode = data.code
    } else if (data && Boolean(element.id)) {
      groupCode = String(element.code)
    }
  })
  return groupCode
}

function checkSpecialGroups(groupCode: string) {
  if (specialGroups.value.includes(String(groupCode))) {
    wrapping.value = wrapping.value.filter((item) => {
      return !specialGroups.value.includes(getGroupCode(item.code))
    })
  }
}

function save() {
  emit('save', wrapping.value)
}

watch(() => [orderStore.orderForm.cargo.dimensions.wrapping, wrappingStore.orderWrappingTypes], () => {
  onShow()
}, { immediate: true })
</script>

<style lang="scss" scoped>
.vz-light-order-wrapping {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>
